import { useBlocNext } from "@blac/react";
import { isPartnerPrimarySsoMethod } from "src/constants/partnerConfig";
import UserCubit from "src/state/UserCubit/UserCubit";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { useBloc } from "src/state/state";

export interface SsoLockedFieldsResult {
  isPartnerSso: boolean;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}

/**
 * Returns partner-SSO status and user preference values that may be used
 * to lock intake funnel fields. The consumer (e.g. DynamicInput) decides which
 * fields to lock based on data presence — inputs themselves stay generic.
 */
const useSsoLockedFields = (): SsoLockedFieldsResult => {
  const [{ userData }] = useBloc(UserCubit);
  const [, { firstName, lastName, dateOfBirth }] =
    useBlocNext(UserPreferencesCubit);

  const isPartnerSso = isPartnerPrimarySsoMethod(
    userData?.sessionAuthenticationMethod
  );

  return { isPartnerSso, firstName, lastName, dateOfBirth };
};

export default useSsoLockedFields;
